import {
  FETCH_APPLICATIONS_REQUEST,
  FETCH_APPLICATIONS_SUCCESS,
  FETCH_APPLICATIONS_FAILURE,
  FETCH_ALL_COUNTS_REQUEST,
  FETCH_ALL_COUNTS_SUCCESS,
  FETCH_ALL_COUNTS_FAILURE,
  LOAD_INITIAL_DATA_REQUEST,
  LOAD_INITIAL_DATA_SUCCESS,
  LOAD_INITIAL_DATA_FAILURE,
  DELETE_APPLICATION_REQUEST,
  DELETE_APPLICATION_SUCCESS,
  DELETE_APPLICATION_FAILURE,
  REJECT_DELETE_REQUEST,
  REJECT_DELETE_SUCCESS,
  REJECT_DELETE_FAILURE,
} from "./DomainApproverApplicationListActions";

const initialState = {
  applications: [],
  loading: false,
  error: null,
  counts: {
    SUBMITTED_FOR_BETA: 0,
    APPROVED_FOR_BETA: 0,
    SUBMITTED_FOR_STAGING: 0,
    APPROVED_FOR_STAGING: 0,
    IN_REVIEW: 0,
    SUBMITTED_FOR_PRODUCTION: 0,
    APPROVED_FOR_PRODUCTION: 0,
    PUBLISHED: 0,
    GENERATING_DELTA: 0,
    DELETED: 0,
    DELISTED_BY_SELLER: 0,
    DELISTED_BY_ADMIN: 0,
    DELISTED_BY_APPROVER: 0,
  },
  countsLoading: false,
  currentStatus: null,
  initialDataLoading: false,
  deleteLoading: false,
  rejectLoading: false,
};

const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPLICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
      
    case FETCH_APPLICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        applications: action.payload.applications,
        currentStatus: action.payload.status,
        error: null,
      };
      
    case FETCH_APPLICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        applications: [],
      };
      
    case FETCH_ALL_COUNTS_REQUEST:
      return {
        ...state,
        countsLoading: true,
      };
      
    case FETCH_ALL_COUNTS_SUCCESS:
      return {
        ...state,
        countsLoading: false,
        counts: {
          ...state.counts,
          ...action.payload,
        },
      };
      
    case FETCH_ALL_COUNTS_FAILURE:
      return {
        ...state,
        countsLoading: false,
      };
    
    case LOAD_INITIAL_DATA_REQUEST:
      return {
        ...state,
        initialDataLoading: true,
        loading: true,
        error: null,
      };
      
    case LOAD_INITIAL_DATA_SUCCESS:
      return {
        ...state,
        initialDataLoading: false,
        loading: false,
        error: null,
      };
      
    case LOAD_INITIAL_DATA_FAILURE:
      return {
        ...state,
        initialDataLoading: false,
        loading: false,
        error: action.payload,
      };
      
    case DELETE_APPLICATION_REQUEST:
      return {
        ...state,
        deleteLoading: true,
      };
      
    case DELETE_APPLICATION_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
      };
      
    case DELETE_APPLICATION_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        error: action.payload,
      };
      
    case REJECT_DELETE_REQUEST:
      return {
        ...state,
        rejectLoading: true,
      };
    
    case REJECT_DELETE_SUCCESS:
      return {
        ...state,
        rejectLoading: false,
      };
      
    case REJECT_DELETE_FAILURE:
      return {
        ...state,
        rejectLoading: false,
        error: action.payload,
      };
    
      case 'UPDATE_DELETED_COUNT':
          return {
              ...state,
              counts: {
                  ...state.counts,
                  DELETED: action.payload
              }
          };

    default:
      return state;
  }
};

export default applicationReducer;